import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Divider, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { StyledLandingComponentContainer, StyledLandingComponentContentWrapper } from './LandingStyles';

const StyledDisclaimerSectionBackground = styled(Box)(() => ({
  width: '100%',
  backgroundColor: outOfBandThemeColors.uMeds.merino100,
}));

const StyledSup = styled('sup')(({ theme }) => ({
  verticalAlign: 'top',
  color: theme.palette.text.secondary,
  fontSize: '.6rem',
}));

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '.75rem',
}));

export const SupContainer = styled(Box)(() => ({
  width: '2ch',
  flexShrink: 0,
}));

export function DisclaimerSection() {
  return (
    <StyledDisclaimerSectionBackground>
      <StyledLandingComponentContainer>
        <StyledLandingComponentContentWrapper>
          <Divider
            orientation="horizontal"
            sx={() => ({
              borderWidth: '1px',
              borderColor: outOfBandThemeColors.uMeds.divider,
              width: '100%',
            })}
          />

          <Box>
            <Stack direction="row" spacing={1} alignItems="flex-start">
              <SupContainer>
                <StyledSup>1.</StyledSup>
              </SupContainer>
              <StyledText>Total uMeds customers serviced from November 2024 to June 2026</StyledText>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
              <SupContainer>
                <StyledSup>2.</StyledSup>
              </SupContainer>

              <StyledText>Total uMeds deliveries from Q2 2023 - Q2 2025</StyledText>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
              <SupContainer>
                <StyledSup>3.</StyledSup>
              </SupContainer>

              <StyledText>uMeds CSAT Survey 2025</StyledText>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
              <SupContainer>
                <StyledSup>4.</StyledSup>
              </SupContainer>

              <StyledText>
                Disclaimer: Before proceeding with a payment option, consider your financial situation to ensure that
                you can afford the full cost of the product purchased, including any applicable fees. Failure to make
                required payments may result in late fees, additional charges, or impact your credit rating. We
                recommend reviewing terms and conditions of the payment option you are choosing and assessing your
                ability to repay before completing your purchase. If you are unsure about your financial ability to meet
                payment obligations, please speak to your doctor about more affordable alternatives.
              </StyledText>
            </Stack>
          </Box>
        </StyledLandingComponentContentWrapper>
      </StyledLandingComponentContainer>
    </StyledDisclaimerSectionBackground>
  );
}
